<template>
  <tr :class="soldOutClass">
    <td v-if="isAdmin">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="product.productChecked">
      </div>
    </td>
    <td>{{ product.brand }}</td>
    <td >
      {{ product.name }}
      <i
        class="material-icons pointer-cursor-edit-name"
        @click="editProductName(product, $event)"
        v-if="isAdmin"
        >
      create
      </i>
    </td>
    <td>
      {{ product.color }}
      <i
        class="material-icons pointer-cursor-edit-name"
        @click="showProductGroupPopup(product, $event)"
        v-if="canShowProductGroupPopup(product)"
        >
      search
      </i>
    </td>
    <td class="hide-mobile">{{ product.category }}</td>
    <td style="min-width: 100px;">
      <div class="text-center">
        {{ productPrice }}
        <i
          class="material-icons pointer-cursor-edit-name"
          @click="editProductPrice(product, $event)"
          v-if="isAdmin"
          >
        create
        </i>
      </div>
    </td>
    <td style="min-width: 120px;">
      <div class="text-center">
        <button class="btn btn-outline-dark btn-circle btn-sm" v-if="properQuantity" @click.prevent="decQuantity">
          <i class="material-icons" >
          remove
          </i>
        </button>
        <span>
          &nbsp;&nbsp;
            <strong>
            {{ productQuantity }}
            </strong>
          &nbsp;&nbsp;
        </span>
        <button class="btn btn-outline-dark btn-circle btn-sm" v-if="properQuantity" @click.prevent="incQuantity">
          <i class="material-icons" >
          add
          </i>
        </button>
      </div>
    </td>
    <td style="min-width: 120px;">
      <div class="input-group-sm">
        <select :class="'form-control status-select ' + assignStatusClassSelect()" @change="handleStatusChange($event)" v-model="productStatus">
          <option :class="assignStatusClass(option.id)" v-for="option in statuses" :key="option.id" v-bind:value="option.id">
            {{ option.text }}
          </option>
        </select>
      </div>
    </td>
    <td class="text-center hide-mobile" v-if="isAdmin">
      <router-link :to="{ name: 'productEdit', params: { id: product.id} }">edytuj</router-link>
    </td>
    <td v-if="isAdmin">
      <button class="btn btn-dark btn-sm" @click="deleteProductConfirm(product.id)">X</button>
    </td>
  </tr>
</template>
<script>

import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import priceUtils from "@/utils/PriceUtils"
import statusUtils from "@/utils/StatusUtils"
import un from 'underscore'
import alertify from 'alertifyjs';

export default {
  name: "ProductItemTable",
  props: ['product'],
  data: () => ({
    statuses: appConfig.editableStatuses(userService.isAdmin()),
    quantity: 0,
    price: 0,
    quantityId: -1,
    productStatus: -1,
    productPreviousStatus: -1,
    updatingQuantity: false
  }),
  created() {
    this.updateContent();
  },
  mounted() {
  },
  destroyed() {
  },
  updated() {
  },
  computed: {
    soldOutClass: function() {
      return this.productStatus === 3 ? "red-font" : ""
    },
    productQuantity: function() {
      return this.quantity;
    },
    properQuantity: function () {
      return un.isNumber(this.quantity)
    },
    productPrice: function () {
      this.price = this.getCurrentStorePrice()
      return priceUtils.formatPrice(this.price) + " zł";
    },
    isAdmin() {
      return userService.isAdmin();
    }
  },
  watch: {
    "product.productChecked": function(value) {
      let data = {
        product: this.product
      }
      if (value) {
        data.action = "add"
      } else {
        data.action = "remove"
      }
      this.$eventHub.$emit("productItemCheck", data);
    }
  },
  methods: {
    canShowProductGroupPopup(product) {
      return product.name
        && product.category
        && product.brand
        && product.color;
    },
    deleteProductConfirm(id) {
      const that = this
      alertify.confirm('', 'Chcesz usunąć produkt z aktualnego sklepu?', function(){
          that.deleteProductFromShop(id)
        }, function(){},
      );
    },
    deleteProductFromShop: function(id) {
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + "/productStatus",
        data: {
          "storeId": userService.getCurrentStore(),
          "productId": this.product.id,
          "status": 4
        },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      });
      req.then(res => {
        const msg = "Usunięto produkt " + this.product.name;
        alertify.set('notifier','position', 'top-center');
        alertify.success(msg).delay(3);
        this.$eventHub.$emit('refreshContent');
      }).catch(_ => {
        console.log("errore deleting ");
      })
    },
    editProductName: function(product, event) {
      const rect = event.target.parentNode.getBoundingClientRect()
      this.$eventHub.$emit("editTableProductName", {
        product: product,
        rect: rect
      });
    },
    editProductPrice: function(product, event) {
      const rect = event.target.parentNode.getBoundingClientRect()
      this.$eventHub.$emit("editTableProductPrice", {
        product: product,
        rect: rect
      });
    },
    showProductGroupPopup: un.throttle(function(product, event){
      const rect = event.target.parentNode.getBoundingClientRect()
      this.$eventHub.$emit("showProductGroupPopup", {
        product: product,
        rect: rect
      });
    }, 90),
    updateContent: function() {
      this.quantity = this.getCurrentStoreQuantity();
      this.price = this.getCurrentStorePrice();
      this.productStatus = this.getCurrentStoreProductStatus();
      this.productPreviousStatus = this.productStatus
    },
    assignStatusClassSelect: function() {
      return appConfig.editableStatusesClass[this.productStatus];
    },
    assignStatusClass: function(id) {
      return appConfig.editableStatusesClass[id];
    },
    handleStatusChange: function(event) {
      if (!userService.isAdmin() && this.productStatus === 5) {
        this.productStatus = this.productPreviousStatus
        alertify.set('notifier','position', 'top-center');
        alertify.error("Tylko administrator może zmienić na status 'brak towaru'.").delay(3);
        return
      }
      const res = statusUtils.statusChangeResponse(this.productStatus, this.quantity)
      const that = this
      switch(res) {
        case 0:
          this.productPreviousStatus = this.productStatus
          this.udateProductStatus();
          break;
        case 1:
          alertify.prompt('', 'Podaj ilość dostępnych produktów', '0',
               function(evt, value) {
                 const newQuantity = parseInt(value)
                 if (isNaN(newQuantity)) {
                   return
                 }
                 that.quantity = newQuantity
                 that.productPreviousStatus = that.productStatus
                 that.productStatus = 1
                 that.udateProductStatus();
                 that.udateQuantity();
               },
               function() { that.productStatus = that.productPreviousStatus })
               .set('labels', {ok:'Ok', cancel:'Anuluj'});
          this.productStatus = this.productPreviousStatus
          break;
        case 2:
          alertify.confirm('', 'Zmieniasz produkt na wyprzedany, zmienic ilość na zero?',
            function(){
              that.quantity = 0
              that.productPreviousStatus = that.productStatus
              that.productStatus = 3
              that.udateProductStatus();
              that.udateQuantity();
            }, function(){
              that.productStatus = that.productPreviousStatus
            })
            .set('labels', {ok:'Tak', cancel:'Nie'});
          this.productStatus = this.productPreviousStatus
          break;
        default:
          this.productStatus = this.productPreviousStatus
      }
    },
    getCurrentStorePrice: function () {
      // const storeId = userService.getCurrentStore();
      // const pp = un.find(this.product.productPrices, item => item.store.id === storeId);
      // if (un.isUndefined(pp))
      //   return 0;
      return this.product.storeData.price;
    },
    getCurrentStoreQuantity: function() {
      // const storeId = userService.getCurrentStore();
      // const av = un.find(this.product.availabilities, item => item.store.id === storeId);
      // if (un.isUndefined(av))
      //   return "Brak danych";
      // this.quantityId = av.id;
      return this.product.storeData.quantity;
    },
    getCurrentStoreProductStatus: function() {
      // const storeId = userService.getCurrentStore();
      // const ps = un.find(this.product.productStatuses, item => item.store.id === storeId);
      // if (un.isUndefined(ps))
      //   return 1;
      return this.product.storeData.status;
    },
    decQuantity: function() {
      if (this.updatingQuantity) {
        return;
      }
      if (un.isNumber(this.quantity) && this.quantity > 0) {
        this.quantity = this.quantity - 1;
        this.udateQuantity();
      }
    },
    incQuantity: function() {
      if (this.updatingQuantity) {
        return;
      }
      if (un.isNumber(this.quantity)) {
        this.quantity = this.quantity + 1;
        this.udateQuantity();
      }
    },
    handleStatusSelect: function() {
      if (this.quantity === 0) {
         this.productStatus = 3;
         this.udateProductStatus();
         return;
       }
       if (this.quantity === 1) {
          this.productStatus = 1;
          this.udateProductStatus();
          return;
        }
        this.updatingQuantity = false;
    },
    udateProductStatus: function() {
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + "/productStatus",
        data: {
          "storeId": userService.getCurrentStore(),
          "productId": this.product.id,
          "status": this.productStatus
        },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      });
      req.then(res => {
        this.updatingQuantity = false;
      })
      .catch(err => {
        this.updatingQuantity = false;
        console.log(err);
      })
    },
    udateQuantity: function() {
      this.updatingQuantity = true;
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + "/availability",
        data: {
          "storeId": userService.getCurrentStore(),
          "productId": this.product.id,
          "quantity": this.quantity
        },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      });
      req.then(res => {
        this.handleStatusSelect();
      }).catch(err => {
        this.updatingQuantity = false;
        console.log(err);
      })
    },
    joinArray: function(arr) {
      return un.map(arr, item => item.name).join(",");
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/product/ProductItemTable.vue